const schema = [
  {
    id: 1,
    step: "a",
    collapsed: true,
    label:
      "Razón social o nombre, Nit, Dirección y Teléfono del domicilio o sede principal de la empresa, entidad u organización.",
    fields: [
      {
        id: 1,
        label: "Razón social",
        type: "text",
        value: "",
      },
      {
        id: 2,
        label: "Nit",
        type: "text",
        value: "",
      },
      {
        id: 3,
        label: "Dirección",
        type: "text",
        value: "",
      },
      {
        id: 4,
        label: "Teléfono",
        type: "text",
        value: "",
      },
    ],
  },
  {
    id: 2,
    step: "b",
    collapsed: true,
    label:
      "Nombre,  cargo  y  correo  electrónico  institucional  del  líder  del  diseño  e implementación del PESV.",
    fields: [
      {
        id: 1,
        label: "Nombre",
        type: "text",
        value: "",
      },
      {
        id: 2,
        label: "Cargo",
        type: "text",
        value: "",
      },
      {
        id: 3,
        label: "Correo",
        type: "email",
        value: "",
      },
    ],
  },
  {
    id: 3,
    step: "c",
    collapsed: true,
    label:
      "Nombre, cargo y  correo electrónico de  auditor(es) del PESV  en  el último año.",
    fields: [
      {
        id: 1,
        label: "Nombre",
        type: "text",
        value: "",
      },
      {
        id: 2,
        label: "Cargo",
        type: "text",
        value: "",
      },
      {
        id: 3,
        label: "Correo",
        type: "email",
        value: "",
      },
    ],
  },
  {
    id: 4,
    step: "d",
    collapsed: true,
    label:
      "Nombre del representante legal de  la  empresa, entidad u organización.",
    fields: [
      {
        id: 1,
        label: "Nombre",
        type: "text",
        value: "",
      },
    ],
  },
  {
    id: 5,
    step: "e",
    collapsed: true,
    label: "Misionalidad y tamaño de la  organización  para efectos del PESV.",
    fields: [
      {
        id: 1,
        label: "Misionalidad",
        type: "text",
        value: "",
      },
      {
        id: 2,
        label: "Tamaño",
        type: "number",
        value: 0,
      },
    ],
  },
  {
    id: 6,
    step: "f",
    collapsed: true,
    label:
      "Número de  vehículos automotores o no  automotores (flota de  vehículos): Tipo y  cantidad  de  vehículos  utilizados  para  desplazamientos  laborales  propios, contratistas, tercerizados y de  propiedad  de  colaboradores  puestos al servicio de  la  organización, de  acuerdo con  lo establecido en  el Capítulo l.  Metodología para el diseño e implementación del PESV.",
    fields: [
      {
        id: 1,
        label: "Tipo de vehículo",
        type: "text",
        value: "",
      },
      {
        id: 2,
        label: "Cantidad",
        type: "number",
        value: 0,
      },
    ],
  },
  {
    id: 7,
    step: "g",
    collapsed: true,
    label:
      "Cantidad  de  colaboradores  de  la  organización  por  tipo  de  actor  vial (conductores, peatones, motociclistas, ciclistas), de acuerdo con  lo establecido en  el Capítulo  l.  Metodología para el diseño e implementación del PESV.",
    fields: [
      {
        id: 1,
        label: "Conductores",
        type: "number",
        value: 0,
      },
      {
        id: 2,
        label: "Peatones",
        type: "number",
        value: 0,
      },
      {
        id: 3,
        label: "Motociclistas",
        type: "number",
        value: 0,
      },
      {
        id: 4,
        label: "Ciclistas",
        type: "number",
        value: 0,
      },
    ],
  },
  {
    id: 8,
    step: "h",
    collapsed: true,
    label:
      "Tipo  y  número  de  contratistas,  subcontratistas  y  terceros,  incluyendo conductores y propietarios de vehículos permanentes y  ocasionales que tienen impacto directo en  la ejecución del PESV.",
    fields: [
      {
        id: 1,
        label: "Contratistas",
        type: "number",
        value: 0,
      },
      {
        id: 2,
        label: "Subcontratistas",
        type: "number",
        value: 0,
      },
      {
        id: 3,
        label: "Terceros",
        type: "number",
        value: 0,
      },
    ],
  },
  {
    id: 9,
    step: "j",
    collapsed: true,
    label:
      "Descripción  de  los  programas  de  gestión  de  riesgos  críticos  y  factores  de desempeño de acuerdo con lo definido en  el Paso  8 (año finalizado y propuestos para el nuevo año).",
    fields: [
      {
        id: 1,
        label: "Descripción",
        type: "textarea",
        value: "",
      },
    ],
  },
  {
    id: 10,
    step: "k",
    collapsed: true,
    label:
      "Número de infracciones por tipo o código de infracción a las normas de tránsito de  los conductores de la organización.",
    fields: [
      {
        id: 1,
        label: "Tipo o código de infracción",
        type: "text",
        value: "",
      },
      {
        id: 2,
        label: "Cantidad",
        type: "number",
        value: 0,
      },
    ],
  },
  {
    id: 11,
    step: "l",
    collapsed: true,
    label:
      "Copia  del  informe  de  la  última auditoría  interna  realizada  al  PESV,  donde  se constate que  el PESV  está implementado y  el nivel de  cumplimiento de  los  24 pasos  establecidos en  la  metodología de PESV.",
    fields: [
      {
        id: 1,
        label: "Informe",
        type: "file",
        value: "",
      },
    ],
  },
];

export default schema;
